module.exports = __webpack_public_path__ + "img/sub7.4b8f3a5e.png";